import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { RecoveryPasskeyPage } from '@egw/features-auth'

export const PasskeyRecoveryPasskeyPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.recovery.title')} />
      <RecoveryPasskeyPage />
    </Layout>
  )
}
